import BOLayout from "@/layouts/bo"
import RouteGuard from "@/utils/route-guard"
import LazyLoadWrapper from "../lazy-load-wrapper"

const RouteGuardWrap = (importFn) => {
  return (
    <BOLayout>
      <RouteGuard mustAuthenticated>
        <LazyLoadWrapper 
          importFn={importFn}
        />
      </RouteGuard>
    </BOLayout>
  );
};

const moduleTitle = "module_title.attendance";

const index = {
  path: "attendance",
  title: moduleTitle,
  sidebarProps: {
    key: "1-5",
    logoSrc: "attendance",
    label: moduleTitle,
    link: "/attendance",
    groupingType: "TOOLS",
    order: 5,
  },
  children: [
    {
      index: true,
      path: "",
      title: moduleTitle,
      element: RouteGuardWrap(() => import("@/pages/attendance/list"))
    },
    {
      path: ":uuid",
      title: moduleTitle,
      headerProps: {
        backUrl: "/attendance"
      },
      element: RouteGuardWrap(() => import("@/pages/attendance/detailed-list"))
    },
  ],
}

export default index